"use client";

import Image from "next/image";
import { useRef } from "react";
import Slider from "react-slick";
import { ProductDetailsResponse } from "@/types/product";
import ViewAllButton from "../view-all-button/ViewAllButton";
import { Typography } from "../typography";
import OfferedProducts from "./offer-products";

interface OfferedProductResponse {
  productsData: ProductDetailsResponse[];
}

const OfferProducts = ({ productsData }: OfferedProductResponse) => {
  const sliderRef = useRef<Slider>(null);

  if (productsData.length < 1) {
    return null;
  }

  const handlePrevClick = () => {
    sliderRef.current?.slickPrev();
  };

  const handleNextClick = () => {
    sliderRef.current?.slickNext();
  };

  return (
    <div className="bg-pageBg">
      <div className="container mx-auto my-16 px-0">
        <div className="flex justify-between mt-0 mb-2 px-4 items-center">
          <div className="w-full lg:w-auto">
            <Typography
              tag="h2"
              className="text-[1.5em] sm:text-[1.7em] text-left"
            >
              Offered Products
            </Typography>
          </div>
          <div className="flex gap-6 items-center">
            <div className="flex gap-2 sm:gap-4">
              <button
                onClick={handlePrevClick}
                className="transition-all rounded-full p-2 sm:p-3 border shadow border-primary hover:scale-105 hover:shadow-md active:scale-100"
              >
                <Image
                  src="/img/arrow-left-slide.svg"
                  alt="Previous"
                  width={20}
                  height={20}
                />
              </button>
              <button
                onClick={handleNextClick}
                className="transition-all rounded-full p-2 sm:p-3 border shadow border-primary hover:scale-105 hover:shadow-md active:scale-100"
              >
                <Image
                  src="/img/arrow-right-slide.svg"
                  alt="Next"
                  width={20}
                  height={200}
                />
              </button>
            </div>
            <div className="hidden lg:flex">
              <ViewAllButton />
            </div>
          </div>
        </div>
        <OfferedProducts data={productsData} sliderRef={sliderRef} />
        <div className="lg:hidden flex  items-center justify-center my-4">
          <ViewAllButton />
        </div>
      </div>
    </div>
  );
};

export default OfferProducts;
